import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const STORAGE_KEY = "malek_cookies_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) setVisible(true);
    } catch (err) {
      console.warn("cookie-banner: localStorage read failed", err);
    }
  }, []);

  const save = (choice) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice, ts: new Date().toISOString() })
      );
      // Also expose a simpler flag the analytics loader can read
      localStorage.setItem("cookie_consent", choice === "all" ? "all" : "essential");
    } catch (err) {
      console.warn("cookie-banner: localStorage write failed", err);
    }
    setVisible(false);
    if (choice === "all") {
      window.dispatchEvent(new Event("cookie-consent-granted"));
    }
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-banner"
      className="fixed inset-x-4 bottom-4 z-[80] mx-auto max-w-[720px] rounded-[1.5rem] bg-white shadow-[0_20px_60px_-15px_rgba(20,10,15,0.35)] border border-[hsl(var(--onyx)/0.08)] p-5 sm:p-6"
    >
      <div className="flex items-start gap-3">
        <div className="flex-1">
          <div className="overline">Cookies</div>
          <p className="mt-2 text-sm text-[hsl(var(--onyx)/0.75)] leading-relaxed">
            We use essential cookies to keep the site working (sign-in, cart). With your permission we'd also use analytics cookies to understand how the site is used. Read our{" "}
            <Link to="/legal/privacy" className="text-[hsl(var(--burgundy))] underline underline-offset-2">
              Privacy Policy
            </Link>
            .
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <button
              onClick={() => save("accept-all")}
              data-testid="cookie-accept"
              className="btn-pill btn-primary !text-xs !py-2"
            >
              Accept all
            </button>
            <button
              onClick={() => save("essential-only")}
              data-testid="cookie-essential"
              className="btn-pill btn-outline !text-xs !py-2"
            >
              Essential only
            </button>
          </div>
        </div>
        <button
          onClick={() => save("dismissed")}
          aria-label="Dismiss"
          data-testid="cookie-close"
          className="w-8 h-8 rounded-full hover:bg-[hsl(var(--onyx)/0.06)] flex items-center justify-center shrink-0"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
